<!-- 消息推送 -->
<template>
  <div class="parent-menu-list">
    <div class="desc">关闭后家长登录系统，将看不到对应的菜单功能</div>
    <div v-for="item in blocks" :key="item.id">
      <van-cell value-class="vc-value">
        <template #title>
          <span class="custom-title">{{ item.menuName }}</span>
        </template>
        <template>
          <van-switch :value="Boolean(item.openStatus)" size="24px" @click="updateStatus(item)" />
        </template>
      </van-cell>
      <div
        class="split"
        v-if="item.menuCode === 'NEW_MSG' || item.menuCode === 'MALL_PORTAL'"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'parent-menu-list',
  data() {
    return {
      pageTitle: '家长端功能设置',
      blocks: [],
    };
  },
  methods: {
    updateStatus(item) {
      this.showLoading();
      this.$api
        .operateParentMenu({
          menuId: item.menuId,
          openStatus: Number(!item.openStatus),
        })
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('修改成功');
            item.openStatus = Number(!item.openStatus);
          } else {
            this.$toast.fail(res.msg || '修改失败');
          }
        });
    },
  },
  created() {
    this.$api.parentMenuList().then(res => {
      this.blocks = res.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.parent-menu-list {
  padding-bottom: calc(var(--gap) * 12);
  .desc {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
  }

  .vc-value {
    flex: none;
  }

  .split {
    height: 12px;
  }
  .custom-title {
    color: var(--g8);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
  }
}
</style>